<template>
  <div>
    <div id="nav" v-if="!mode || mode == 'main' || mode == 'combo-detail' ">
      <div class="mycontainer">
        <ul>
          <li v-for="(item, index) in categoryList" v-bind:key="item.uuid" class="" v-if="$const.NON_LOCALIZATION_CATEGORY.indexOf(item.slug) < 0 || hasDisposition"
              v-bind:class="{active: $route.name == $const.HEADER_MENU.CATEGORY && (selectedCategory && item.uuid == selectedCategory.uuid) }"
              v-on:click="changeCategory(item.slug, item)">
            <a href="javascript: void(0)" class="lg-cond" hreflang="en-MY">{{item.name}}</a>
          </li>
          <li v-bind:class="{active: $route.name == $const.HEADER_MENU.CATEGORY && (selectedCategory && selectedCategory.uuid == $const.COUPON_UUID)}"
              v-on:click="changeCategory('coupons')">
            <a href="javascript: void(0)" class="lg-cond" hreflang="en-MY">{{ $t('coupons_vouchers') }}</a>
          </li>
          <li v-bind:class="$route.name == $const.HEADER_MENU.TOPIC || $route.name == $const.HEADER_MENU.TOPIC_DETAIL ? 'active' : ''"
              v-on:click="redirectTo($const.HEADER_MENU.TOPIC)">
            <a href="javascript: void(0)" class="lg-cond">{{ $t('footer.topics') }}</a>
          </li>
        </ul>
        <div
          v-if="$route.name == $const.HEADER_MENU.CATEGORY && (selectedCategory && selectedCategory.lower_categories)"
          class="flex">
          <div v-for="(item, index) in selectedCategory.lower_categories"
               v-bind:key="item.uuid"
               v-on:click="changeCategory(item.slug, selectedCategory, item)"
               :class="'sub_category flex-1' + (selectedSubCategory.uuid == item.uuid ? ' active' : '')">
            <span>{{item.name}}</span></div>
        </div>
      </div>
    </div>
    <div v-else-if="mode == 'footer'">
      <a href="javascript: void(0)" hreflang="en-MY" v-for="(item, indexc) in categoryList" class="clear" :key="indexc"
         v-on:click="changeCategory(item.slug, item.uuid)"><span class="capitalize">{{ item.name}}</span></a>
      <a href="javascript: void(0)" hreflang="en-MY" class="clear" key="nav_footer--coupon"
        v-on:click="changeCategory('coupons')"><span class="capitalize">{{ $t('coupons') }}</span></a>
      <a href="javascript: void(0)" v-on:click="changeCategory('vouchers')" hreflang="en-MY" class="clear" key="nav_footer--voucher"><span class="capitalize">{{ $t('vouchers') }}</span></a>
    </div>

    <div class="main-content container-attribute-filter" v-if="!empty(attributeList) && !isCombo && (selectedCategory && selectedCategory.uuid != $const.COUPON_UUID)">
      <div class="mycontainer">
        <div class="flex">
          <div v-if="!empty(getTextInErrorMessage('FILTER-TEXT'))" class="font-bold text-nowrap pr-10 mt-10">{{getTextInErrorMessage('FILTER-TEXT')}}</div>
          <div v-if="isMobile()" class="party-mobile">
            <input id="party" @click="showModal" ref="party" class="input" v-model="singleName" type="text">
            <i @click="showModal" class="fa header-time__arrow--down aline-mid fa-angle-down"></i>
          </div>
          <div v-else class="flex flex-wrap items-center">
            <div v-on:click="filterClick(att)" class="cursor-pointer item-attr text-nowrap" :class="{'active': attributeFilter && attributeFilter.indexOf(att.uuid) >=0 }"  v-for="(att, indexA) in attributeList" :key="indexA" :title="att.name">
              <img v-bind:src="att.image.icon" alt="" v-if="att.image && att.image.icon" class="p0" style="height: 20px !important"> {{att.name}}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="main-content container-attribute-filter" v-if="!empty(attributeList) && isCombo && filterCombo && (selectedCategory && selectedCategory.uuid != $const.COUPON_UUID)">
      <div class="mycontainer">
        <div class="flex">
          <div v-if="!empty(getTextInErrorMessage('FILTER-COMBO-TEXT'))" class="font-bold text-nowrap mr-10 mt-10">{{getTextInErrorMessage('FILTER-COMBO-TEXT')}}</div>
          <div v-if="isMobile()" class="party-mobile">
            <input id="party" @click="showModal" ref="party" class="input" v-model="chooseFilterCombo.name" type="text">
            <i @click="showModal" class="fa header-time__arrow--down aline-mid fa-angle-down"></i>
          </div>
          <div v-else class="flex flex-wrap items-center">
            <div v-on:click="filterClick(att)" class="cursor-pointer item-attr text-nowrap" :class="{'active': (attributeFilter && attributeFilter.indexOf(att.uuid) >=0) || (activeAllfilter && att.uuid === allFilter.uuid) }"  v-for="(att, index) in attributeList" :key="index" :title="att.name">
              <img v-bind:src="att.image.icon" alt="" v-if="att.image && att.image.icon" class="p0" style="height: 20px !important"> {{att.name}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
  .sub_category {
    cursor: pointer;
    text-align: center;
    height: 50px;
    line-height: 50px;
    /*font-family: UnitedSansCdBd, Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif !important;*/
    border-top: 1px solid #e9ebee !important;
  }

  .sub_category:not(:last-child) {
    border-right: 1px solid #e9ebee !important;
  }

  .sub_category.active {
    color: #da291c;
  }

  .sub_category:hover {
    color: #da291c;
  }

  .container-attribute-filter {
    padding: 15px 10px;
    background: #fff;
    -webkit-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1);
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1);
  }

  .container-attribute-filter .title-attr {
    font-size: 16px;
    line-height: 22px;
    color: #000000;
    display: inline-block;
  }

  .container-attribute-filter .item-attr {
    background: #FFFFFF;
    padding: 5px 10px;
    margin: 5px;
    box-shadow: inset 0px -1px 0px #DFDFE3, inset -1px 0px 0px #DFDFE3, inset 0px 1px 0px #DFDFE3, inset 1px 0px 0px #DFDFE3;
    border-radius: 5px;
    display: inline-block;
    min-width: 40px;
  }

  .container-attribute-filter .item-attr.active{
    border: 1px solid #0A8020;
  }

  .party-mobile {
    width: 100%;
    position: relative;
  }

  .party-mobile>input {
    border: 1px solid hsla(207, 8%, 51%, .5);
  }

  .party-mobile>i {
    position: absolute;
    top: 15px;
    right: 10px;
  }

  @media (max-width: 800px) {
    .container-attribute-filter {
      position: absolute;
      float: left;
      top: 117px;
      width: 100%;
      z-index: 1001;
    }
  }

  .align-left {
    left: -7px;
  }

  .mr-left {
    margin-left: -2.5%;
  }

  @media (max-width: 500px) {
    .sub_category {
      line-height: unset;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: center !important;
      -webkit-align-items: center !important;
      -ms-flex-align: center !important;
      align-items: center !important;
    }

    .sub_category span {
      width: 100%;
      font-size: 1.2rem;line-height: 1.4rem; font-family: Open Sans, sans-serif;
    }
    .sub-category::after {
      bottom: -1px;
    }
    .mr-left {
      margin-left: -1%;
    }
  }
</style>
<script>
  import moment from 'moment'
  import * as action from '../../store/actions'
  import {
    mapState,
    mapGetters,
    mapActions
  } from 'vuex'
  import vSelect from 'vue-select'

  const ModalPopup  = () => import ('../popup/ModalPizza.vue')
  const ModalPopupHalf  = () => import ('../popup/ModalPizzaHalf.vue')
  const ModalParty = () => import('../popup/ModalParty.vue')

  export default {
    props: ['mode'],
    data: function () {
      return {
        slug: this.$route.params.slug,
        slugSub: this.$route.params.sub,
        slugParent: this.$route.params.slug,
        uuid: this.$route.params.uuid,
        sub: [],
        active: false,
        hasDisposition: false,
        currentSelectedCategory: null,
        filterCombo: false,
        isCombo: false,
        allFilter: {
          image: {},
          name: this.$t('all'),
          sequence: -1,
          uuid: '0000'
        },
        activeAllfilter: true,
        chooseFilterCombo: {
          image: {},
          name: this.$t('all'),
          sequence: -1,
          uuid: '0000'
        },
        singleName: this.$t('all_types'),
        chooseFilterSingle: []
      }
    },
    computed: {
      ...mapState({
        attributeList: 'attributeList',
        attributeFilter: 'attributeFilter'
      }),
      ...mapGetters({
        selectedCategoryId: 'category_uuid',
        selectedProduct: 'selectedProduct',
        selectedCartId: 'selectedCartId',
        selectedCategory: 'selectedCategory',
        selectedSubCategory: 'selectedSubCategory',
        selectedCart: 'selectedCart',
        categoryList: 'categoryList',
        selectedDisposition: 'selectedDisposition',
        uuidForNameSeoDuplicate: 'uuidForNameSeoDuplicate'
      })
    },
    watch: {
      selectedDisposition: function (newValue, oldValue) {
        if (newValue && !this.empty(newValue) && newValue.outletCode != '') {
          this.hasDisposition = true
        } else {
          this.hasDisposition = false
        }
      },
      '$route'(to, from) {
        this.routeChanged(to, from);
      },
      selectedCategory: function (newValue, oldValue) {
        if (this.selectedSubCategory) {
          this.currentSelectedCategory = this.selectedSubCategory;
        } else {
          this.currentSelectedCategory = this.selectedCategory;
        }
      },
      selectedSubCategory: function (newValue, oldValue) {
        if (this.selectedSubCategory) {
          this.currentSelectedCategory = this.selectedSubCategory;
        } else {
          this.currentSelectedCategory = this.selectedCategory;
        }
      },
      selectedProduct: function (newValue, oldValue) {
        this.showPopup(this.selectedProduct, this.currentSelectedCategory);
      },
      selectedCart: function (selectedCart, oldValue) {
        if (selectedCart) {
          let vm = this
          let category = getCategory(selectedCart.cartId, vm.categoryList)

          vm.getProduct(selectedCart.nameSeo || selectedCart.productUuid, selectedCart.isHalf, selectedCart.isLunch, function (res, err) {
            vm.setSelectedProduct(res)
          })
        }
      }
    },
    components: {
        vSelect
    },
    created() {
      this.routeChanged(this.$route)
      this.getConfigTenant()
    },
    mounted() {
      let vm = this
      this.hasDisposition = this.checkPosition(this)

      if (this.$route.params.sub) {
        this.slug = this.$route.params.sub;
      }

      this.$root.$on('navchanged', (slug) => {
        this.slug = slug
      })

      this.$root.$on('checkIsCombo', (slug) => {
        vm.isCombo = slug === vm.$const.MENU_DEAL
        if(vm.isCombo) {
          let checkAllFilter = vm.attributeList.filter(att => att.uuid === vm.allFilter.uuid)
          if(checkAllFilter.length <= 0) {
            vm.attributeList.unshift(vm.allFilter)
          }
        }
      })
      
      this.$root.$on('chooseFilter', (chooseFilter) => {
        this.setAttributeFilter([])
        if (vm.isCombo) {
          vm.chooseFilterName = chooseFilter.name
          vm.chooseFilterCombo = chooseFilter
          vm.filterClick (chooseFilter)
        } else {
          vm.chooseFilterSingle = chooseFilter
          if(chooseFilter.length > 0) {
            let joinName = chooseFilter.map(function(elem){
                return elem.name;
            }).join(", ")
            
            chooseFilter.forEach(att => {
              if (chooseFilter.length > 1) {
                vm.singleName = joinName
              } else {
                vm.singleName = att.name
              }
              vm.filterClick(att)
            });
          } else {
            vm.singleName = vm.$t('all_types')
            vm.chooseFilterSingle = []
          }
        }
      })
    },
    destroyed() {
      this.$root.$off('checkIsCombo')
      this.$root.$off('chooseFilter')
    },
    methods: {
      ...mapActions({
        setSelectedProduct: action.SET_SELECTED_PRODUCT,
        setSelectedCategory: action.SET_SELECTED_CATEGORY,
        setAttributeFilter: action.SET_ATTRIBUTES_FILTER,
        setSelectedSubCategory: action.SET_SELECTED_SUB_CATEGORY
      }),
      getConfigTenant () {
        let vm = this
        let params = {
          manual: 1
        }
        vm.axios.apiTenant.getConfigByClient(params, function (response) {
          const value = vm.getValueFromAttr(response, 'data.data.item.filter_combo', false)
          vm.filterCombo = (value === 1 || value === '1' || value === true || value === 'true') || false
          const minOnlinePayment = vm.getValueFromAttr(response, 'data.data.item.online_payment_threshold', 0)
          vm.$session.set('minOnlinePayment', minOnlinePayment)
        })
      },
      filterClick (item) {
        let filter = []
        if(this.isCombo) {
          if (item.uuid !== this.allFilter.uuid) {
            filter.push(item.uuid)
            this.activeAllfilter = false
          } else {
            this.activeAllfilter = true
          }
        } else {
          filter = this.attributeFilter
          if (this.attributeFilter && this.attributeFilter.indexOf(item.uuid) >= 0) {
            filter = []
            for (let i in this.attributeFilter) {
              if (this.attributeFilter[i] !== item.uuid) {
                filter.push(this.attributeFilter[i])
              }
            }
          } else {
            filter.push(item.uuid)
          }
        }
        this.setAttributeFilter(filter)
      },
      routeChanged(to = null, from = null) {
        let vm = this;
        let subSlug = to.params.sub
        let parentSlug = to.params.slug
        let nameSeo = to.params.nameseo

        vm.slug = to.params.slug
        vm.slugParent = vm.slug

        if (to.params.sub) {
          vm.slugSub = to.params.sub
          vm.slug = to.params.sub
        }

        if (to.name === vm.$const.HEADER_MENU.CATEGORY || to.name === vm.$const.HEADER_MENU.COMBO_DETAIL) {
          if (subSlug || nameSeo) {
            let isHalf = (subSlug === vm.$const.HEADER_MENU.HALF_HAlF || (nameSeo === vm.$const.HEADER_MENU.HALF_HAlF))
            let param = nameSeo || subSlug
            let onlyLunch = vm.$const.HALF_HALF_SET.NORMAL

            if (to.params.nameSeo === vm.$const.HEADER_MENU.LUNCH_SET) {
              onlyLunch = vm.$const.HALF_HALF_SET.LUNCH
            }

            vm.getProduct(param, isHalf, onlyLunch, function (res, err) {
              if (res) {
                vm.setSelectedProduct(res)
                document.title = vm.$t('title_detail_menu', {title: res.name_en || ''})
                if (document.getElementsByTagName('meta')['description'] === undefined) {
                  let meta = document.createElement('meta')
                  meta.setAttribute('name', 'description')
                  meta.setAttribute('content', res.marketing_description || '')
                  document.head.appendChild(meta)
                } else {
                  let descriptionEl = document.getElementsByTagName('meta')['description']
                  descriptionEl.content = vm.$t('description_detail_menu', {name: res.name_en || '', des: res.marketing_description || ''})
                }
              }
            })
          }
        }
      },
      getProduct(nameSeo, isHalf = false, onlyLunch = false, callback) {
        let vm = this
        if((this.selectedSubCategory && _.lowerCase(nameSeo) == _.lowerCase(this.selectedSubCategory.slug)) ||
          (this.selectedCategory && _.lowerCase(nameSeo) == _.lowerCase(this.selectedCategory.slug)) ||
          (vm.$route.params.slug === vm.$const.MENU_DEAL && vm.$route.params.sub)) {
          return
        }

        if (isHalf) {
          let res = {};
          res.uuid = moment().format('x');
          res.isHalf = true;
          res.onlyLunch = onlyLunch
          callback(res);
        } else {
          vm.getProductByNameseo(nameSeo, function (res, err) {
            callback(res, err);
          })
        }
      },
      changeCategory(slug, category, subCategory = null) {
        let vm = this
        let subSlug = null;
        let selectedCategory = category;
        let selectedSubCategory = subCategory;
        vm.isCombo = slug === vm.$const.MENU_DEAL
        vm.chooseFilterSingle = []
        vm.singleName = vm.$t('all_types')
        vm.chooseFilterCombo = {
          image: {},
          name: this.$t('all'),
          sequence: -1,
          uuid: '0000'
        }

        if (!subCategory) {
          if(category && category.lower_categories && category.lower_categories.length){
            subSlug = category.lower_categories[0].slug
            selectedSubCategory = category.lower_categories[0]
          }
        }else{
          subSlug = selectedSubCategory.slug
        }

        if (slug == vm.$const.HEADER_MENU.COUPON) {
          selectedCategory = {
            display_type: {web: 4, mobile: 2},
            lower_categories: [],
            name: vm.$t('coupons'),
            only_lunch: 0,
            piece: 1,
            slug: slug,
            uuid: vm.$const.COUPON_UUID
          }
        }

        if (slug == vm.$const.HEADER_MENU.VOUCHER) {
          return vm.$router.push({'name': slug})
        }

        vm.setSelectedCategory(selectedCategory)
        vm.setSelectedSubCategory(selectedSubCategory)
        vm.smartechViewCategory(vm,selectedCategory,vm.$router)

        if(subSlug){
          vm.redirectToMenuPage(selectedCategory.slug, subSlug);
        }else{
          vm.redirectToMenuPage(slug);
        }
      },
      showPopup(product = null) {
        let vm = this
        if (product) {
          let popup = product.isHalf ? ModalPopupHalf : ModalPopup;
          let params = {
            menu: product,
            scrollable: false,
            mfirst: {},
            msecond: {},
            extraCheese: [],
          };

          if (product.isHalf) {
            params.onlyLunch = product.onlyLunch
          }

          vm.$modal.show(popup, params, {
            class: 'modal-menu',
            clickToClose: false,
            name: 'close-modal-menu'
          }, {
            'before-open': function (event) {
              document.body.classList.add('modal-open')
            },
            'closed': function (event) {
              vm.$root.$emit('onTrackingCategory')
            },
            'opened': function (event) {
            },
          })
        }
      },
      showModal () {
        let vm = this
        vm.$modal.show(ModalParty, {
          attributeList: vm.attributeList,
          allFilter: vm.isCombo ? vm.chooseFilterCombo : vm.chooseFilterSingle,
          isCombo: vm.isCombo
        }, {
          class: ''
        })
      }
    }
  }

  function getCategory(uuid, categoryList) {
    for (let iCategory in categoryList) {
      if (categoryList[iCategory].uuid == uuid) {
        return categoryList[iCategory];
      } else {
        let lowerCategories = categoryList[iCategory].lower_categories;

        if (lowerCategories && lowerCategories.length) {
          for (let iSubCategory in lowerCategories) {
            if (lowerCategories[iSubCategory].uuid == uuid) {
              return lowerCategories[iSubCategory];
            }
          }
        }
      }
    }

    return null;
  }

</script>



// WEBPACK FOOTER //
// src/components/partials/NavCategory.vue